export default "__VITE_ASSET__ByliErpK__"